import { get } from 'aws-amplify/api';
import { getAuthHeaders } from 'utils/commonUtils';

export const getDashboard = async () => {
  const { body } = await get({
    apiName: 'deltaSnp-api',
    path: '/dashboard',
    options: { headers: await getAuthHeaders() },
  }).response;
  return body.json();
};
